/**
 * Created by pzf on 18/9/1.
 *
 */
/* eslint func-names: 1 */
import React from 'react';
import { Modal, Input, Icon, Button } from 'mkui-fd';
import classNames from 'classnames';
import { propTypes, defaultPropTypes } from './PropTypes';
import { addSelected, remove, isSelect, batchAdd } from './util';
import SelectedItem from './SelectedItem';
import ListItem from './ListItem';
import CategoryItem from './CategoryItem';

const { Search } = Input;

class TransferModal extends React.Component {
  /** *******************static************************** */
  static propTypes = propTypes;

  static defaultProps = defaultPropTypes;

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  /** 处理 modalManager open 场景  */
  componentDidMount() {
    if (this.props.visible && this.props.api) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      if (this.props.api) {
        this.setState({ loading: true });
        this.fetchData();
      }
      this.synStateFromValue();
    }
    if (!this.props.api && this.props.data !== prevProps.data) {
      this.setState({ data: this.props.data });
    }
  }

  /** *******************handle************************** */
  /**
   * 选择后触发
   * @param item
   */
  selectHandle(item) {
    const { choosed } = this.state;
    const { keyName, multiple } = this.props;
    if (isSelect(choosed, item, keyName)) {
      return;
    }
    this.setChoosedState(addSelected(choosed, item, multiple));
  }

  /**
   * 更多点击触发
   * @param e
   */
  moreClickHandle(e) {

  }

  okHandle() {
    const { onOk } = this.props;
    if (onOk) {
      onOk(this.buildReturnData());
    }
  }

  cancelHandle() {
    const { onCancle } = this.props;
    if (onCancle) {
      onCancle();
    }
  }

  clearHandle(e) {
    this.setChoosedState([]);
  }

  removeHandle(item) {
    const { choosed } = this.state;
    const { keyName } = this.props;
    this.setChoosedState(remove(choosed, item, keyName));
  }

  batchAddHandle(category) {
    const { keyName } = this.props;
    const { choosed } = this.state;
    this.setChoosedState(batchAdd(choosed, category, keyName));
  }

  searchHandle(keyword) {
    this.searchData(keyword);
  }


  /** *******************inner method************************** */

  getInitState(props) {
    const { value, api, data } = this.props;
    if (api) {
      return { choosed: value || [], loading: true };
    } else {
      return { data: data || null, choosed: value || [], loading: false };
    }
  }

  /**
   * 同步state
   */
  synStateFromValue() {
    const { value } = this.props;
    this.setChoosedState(value);
  }

  fetchData() {
    const { api, params } = this.props;
    api(params).then((data) => {
      this.setState({ data, loading: false });
      this.loaded = true;
    });
  }

  searchData(keyword) {
    const { api, params, keyName, keyWordName } = this.props;
    const queryParams = keyWordName ? { [keyWordName]: keyword } : { [keyName]: keyword };
    api({ ...params, ...queryParams }).then((data) => {
      this.setState({ data });
    });
  }

  fireChange(choosed) {
    const { onChange } = this.props;
    onChange(values);
  }

  setChoosedState(choosed) {
    this.setState({ choosed });
  }

  buildReturnData() {
    const { choosed } = this.state;
    return choosed;
  }


  /** *******************render method************************** */

  renderSearch() {
    const { prefixCls, searchPlaceholder } = this.props;
    return (
      <div className={`${prefixCls}-left-panel-search`}><Search placeholder={searchPlaceholder}
        onSearch={(value) => this.searchHandle(value)}
      />
      </div>
    );
  }

  renderLeftPanel() {
    const { prefixCls, subTitle, showSearch } = this.props;
    return (
      <div className={`${prefixCls}-panel ${prefixCls}-left-panel`}>
        <div className={`${prefixCls}-panel-head ${prefixCls}-left-panel-head`}><span
          className={`${prefixCls}-right-panel-head-title`}
        >{subTitle}
        </span>
        </div>
        {showSearch ? this.renderSearch() : null}
        <div className={`${prefixCls}-panel-body ${prefixCls}-left-panel-body`}>

          {this.renderLeftContent()}
        </div>
      </div>
    );
  }

  renderLeftContent() {
    const { prefixCls } = this.props;
    const { loading, data } = this.state;
    if (loading) {
      return <Icon type="loading" className={`${prefixCls}-left-panel-loading`} />;
    } else {
      return (
        <ul className={`${prefixCls}-panel-body-content ${prefixCls}-left-panel-body-content`}>
          {data.map((item) => this.renderLeftItem(item))}
        </ul>
      );
    }
  }

  renderLeftItem(item) {
    const { choosed } = this.state;
    const { keyName, categoryKeyName, render, categoryRender, multiple } = this.props;
    if (item.children && item.children.length) {
      return (
        <CategoryItem key={item[categoryKeyName]}
          name={categoryRender(item)}
          onBatchClick={() => this.batchAddHandle(item)}
          batchAddBtn={multiple}
        >
          {item.children.map((item) => (
            <ListItem name={render(item)}
              key={item[keyName]}
              disabled={isSelect(choosed, item, keyName)}
              onSelect={() => {
                this.selectHandle(item);
              }}
            />
          ))}
        </CategoryItem>
      );
    } else {
      return (
        <ListItem name={render(item)}
          key={item[keyName]}
          disabled={isSelect(choosed, item, keyName)}
          onSelect={() => {
            this.selectHandle(item);
          }}
        />
      );
    }
  }


  renderRightPanel() {
    const { prefixCls, keyName, render, multiple } = this.props;
    const { choosed } = this.state;
    return (
      <div className={`${prefixCls}-panel ${prefixCls}-right-panel`}>
        <div className={`${prefixCls}-panel-head ${prefixCls}-right-panel-head`}>
          <span className={`${prefixCls}-right-panel-head-info`}>
            <span
              className={`${prefixCls}-right-panel-head-info-prefix`}
            >已选:
            </span>
            <span
              className={`${prefixCls}-right-panel-head-info-count`}
            >{choosed.length}
            </span>
            <span
              className={`${prefixCls}-right-panel-head-info-suffix`}
            >项
            </span>
          </span>
          <Button className={`${prefixCls}-right-panel-head-clear`}
            onClick={(event) => {
              this.clearHandle(event);
            }}
            type="link"
          >全部清空
          </Button>
        </div>
        <div className={`${prefixCls}-panel-body ${prefixCls}-right-panel-body`}>
          {!multiple ? <span className={`${prefixCls}-right-panel-body-info`}><Icon type="info-circle" theme="filled" /> 单选模式，只能选定一项</span> : null}
          <ul className={`${prefixCls}-panel-body-content ${prefixCls}-right-panel-body-content`}>
            {choosed.map((item) => (
              <SelectedItem name={render(item)}
                key={item[keyName]}
                onRemove={() => {
                  this.removeHandle(item);
                }}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  }


  renderOperation() {
    const { prefixCls } = this.props;
    return (
      <div className={`${prefixCls}-middle-operation`}>
        <Icon type="right" />
      </div>
    );
  }


  render() {
    const { visible, prefixCls, title, showSearch, zIndex } = this.props;
    const wrapperCls = classNames(`${prefixCls}`, {
      [`${prefixCls}-has-search`]: showSearch,
    });
    return (
      <Modal
        title={title}
        visible={visible}
        zIndex={zIndex}
        cancelText="取消"
        okText="确定"
        onOk={() => {
          this.okHandle();
        }}
        width={800}
        wrapClassName={wrapperCls}
        onCancel={() => {
          this.cancelHandle();
        }}
      >
        {this.renderLeftPanel()}
        {this.renderOperation()}
        {this.renderRightPanel()}
      </Modal>
    );
  }
}

export default TransferModal;
